import { createContext } from 'react'

import { rootStore } from 'admin/stores'

const StoreContext = createContext(rootStore)

export {
  StoreContext,
}
